export const MAX_MAGICKA = 12;
export const STARTING_HEALTH = 30;
export const STARTING_MAGICKA = 1;
export const STARTING_HAND_SIZE = 4;
export const LANE_SIZE = 4;
export const DECK_SIZE = 40;
export const RUNE_THRESHOLDS = [5, 10, 15, 20, 25];
export const KEYWORDS = ['guard', 'charge', 'breakthrough', 'lethal', 'ward', 'drain'];
export const MAX_HAND_SIZE = 10;
